export default __webpack_public_path__ + "static/media/idaDashboardImg.959dc244.jpg";